import toPath from "./_toPath.js";
import deepGet from "./_deepGet.js";
import isUndefined from "./isUndefined.js";
export default function get(object, path, defaultValue) {
  var value = deepGet(object, toPath(path));
  return isUndefined(value) ? defaultValue : value;
}
